import { AxiosPromise } from 'axios';

const API_PATH = process.env.REACT_APP_API_URL;

type API = {
  post: (url: string, payload: any) => AxiosPromise
  put: (url: string, payload: any) => AxiosPromise
  get: (url: string) => AxiosPromise
  delete: (id: string) => AxiosPromise
}

const soulsaraVideoContents = (api: API) => {

  // latest videos
  const addLatestVideos = (payload: any) => api.post(API_PATH + '/ss_video/', payload)
  const getLatestVideos = () => api.get(API_PATH + '/ss_video/')
  const deleteLatestVideos = (id: string) => api.delete(API_PATH + `/ss_video/${id}`)
  const editLatestVideos = (id: string) => api.get(API_PATH + `/ss_video/${id}`)
  const updateLatestVideos = (id: string, payload: any) => api.put(API_PATH + `/ss_video/${id}`, payload)
  const updateLatestVideosThu = (id: string, payload: any) => api.put(API_PATH + `/ss_video/thumbnail/${id}`, payload)

  const getShortVideos=()=>api.get(API_PATH + `/api/videos/videoType/short`)
  const getAWAAgoraVideos=()=>api.get(API_PATH + `/api/videos/videoType/awa_agora`)
  const getSoulsaraVideos=()=>api.get(API_PATH + `/ss_video/videoType/events`)
  const getSoulsaraShortVideos=()=>api.get(API_PATH + `/ss_video/videoType/events_shorts`)
  const getSoulstudioVideos=()=>api.get(API_PATH + `/api/videos/videoType/soulstudio`)
  const getCommonVideos=()=>api.get(API_PATH + `/api/videos/videoType/common`)
  
  return {updateLatestVideosThu,
    addLatestVideos,
    getLatestVideos,
    deleteLatestVideos,
    editLatestVideos,
    updateLatestVideos,
    getShortVideos,
    getAWAAgoraVideos,
    getSoulsaraVideos,
    getSoulsaraShortVideos,
    getSoulstudioVideos,
    getCommonVideos
  }
}

export default soulsaraVideoContents
